import { Uri as innerUri } from './dupes/URI.js';


export const Uri = innerUri;
